const selectors = {
  productButton: '[data-button="product"]',
  pageButton: '[data-button="page"]',
  productContainer: '[data-product-container]',
  pageContainer: '[data-page-container]',
};

if (!customElements.get('search-picker')) {
  customElements.define(
    'search-picker',
    class SearchPicker extends HTMLElement {
      constructor() {
        super();
        this.elements = this._getElements();
        this.params = new URL(document.location).searchParams;
        this.searchType = this.params.get('type');

        if (Object.keys(this.elements).length === 0) return;

        if (
          this.searchType == 'article' ||
          this.searchType == 'page' ||
          this.searchType == 'article,page' ||
          this.searchType == 'page,article'
        ) {
          this._activatePageContainer();
        } else {
          this._activateProductContainer();
        }

        this._setupEventListeners();
      }

      _refreshToProduct() {
        if ('URLSearchParams' in window) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set('type', 'product');
          searchParams.set('page', '1');
          window.location.search = searchParams.toString();
        }
      }

      _refreshToPage() {
        if ('URLSearchParams' in window) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set('type', 'article,page');
          searchParams.set('page', '1');
          window.location.search = searchParams.toString();
        }
      }

      _activateProductContainer() {
        this._removeActiveElements();
        this.elements.productButton.classList.add('active');
        this.elements.productContainer.classList.add('active');
      }

      _activatePageContainer() {
        this._removeActiveElements();
        this.elements.pageButton.classList.add('active');
        this.elements.pageContainer.classList.add('active');
      }

      _removeActiveElements() {
        this.elements.productButton.classList.remove('active');
        this.elements.pageButton.classList.remove('active');
        this.elements.productContainer.classList.remove('active');
        this.elements.pageContainer.classList.remove('active');
      }

      _getElements() {
        return {
          productButton: document.querySelector(selectors.productButton),
          pageButton: document.querySelector(selectors.pageButton),
          productContainer: document.querySelector(selectors.productContainer),
          pageContainer: document.querySelector(selectors.pageContainer),
        };
      }

      _setupEventListeners() {
        this.elements.productButton.addEventListener(
          'click',
          this._refreshToProduct.bind(this),
        );
        this.elements.pageButton.addEventListener(
          'click',
          this._refreshToPage.bind(this),
        );
      }
    },
  );
}
